import React, { useRef, useEffect, useState } from "react";

const CardTipo = ({ categorias, onSeleccionar, activa }) => {
  const contenedorRef = useRef(null);
  const [mostrarFlechas, setMostrarFlechas] = useState(false);

  const scroll = (direction) => {
    if (!contenedorRef.current) return;
    const scrollAmount = 200;
    contenedorRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const verificarOverflow = () => {
    const el = contenedorRef.current;
    if (el) {
      setMostrarFlechas(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    verificarOverflow();
    window.addEventListener("resize", verificarOverflow);
    return () => {
      window.removeEventListener("resize", verificarOverflow);
    };
  }, [categorias]);

  return (
    <>
      {/* 📱 Vista móvil: scroll táctil */}
      <div
        className="d-flex d-md-none overflow-auto flex-nowrap pb-2 px-2"
        style={{
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {categorias.map((cat) => (
          <div
            key={cat.id}
            className={`card me-2 ${cat.id === activa ? "border-primary" : ""}`}
            onClick={() => onSeleccionar(cat.id)}
            style={{
              width: "10rem",
              flex: "0 0 auto",
              scrollSnapAlign: "start",
              cursor: "pointer",
              borderWidth: "2px",
            }}
          >
            <img
              src={cat.imagen}
              className="card-img-top"
              alt={cat.nombre}
              style={{ objectFit: "cover", height: "8rem" }}
            />
            <div className="card-body p-2">
              <h6 className="card-title text-center" style={{ fontSize: "0.9rem", margin: 0 }}>
                {cat.nombre}
              </h6>
            </div>
          </div>
        ))}
      </div>

      {/* 💻 Vista escritorio: flechas solo si hay overflow */}
      <div className="position-relative d-none d-md-block">
        {mostrarFlechas && (
          <button
            type="button"
            className="btn btn-light position-absolute"
            onClick={() => scroll("left")}
            style={{
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              borderRadius: "50%",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
            }}
          >
            <i className="fas fa-chevron-left"></i>
          </button>
        )}

        <div
          ref={contenedorRef}
          className="d-flex flex-nowrap px-2"
          style={{
            overflow: "hidden",
          }}
        >
          {categorias.map((cat) => (
            <div
              key={cat.id}
              className={`card me-2 ${cat.id === activa ? "border-primary" : ""}`}
              onClick={() => onSeleccionar(cat.id)}
              style={{
                width: "10rem",
                flex: "0 0 auto",
                cursor: "pointer",
                borderWidth: "2px",
              }}
            >
              <img
                src={cat.imagen}
                className="card-img-top"
                alt={cat.nombre}
                style={{ objectFit: "cover", height: "8rem" }}
              />
              <div className="card-body p-2">
                <h6 className="card-title text-center" style={{ fontSize: "0.9rem", margin: 0 }}>
                  {cat.nombre}
                </h6>
              </div>
            </div>
          ))}
        </div>

        {mostrarFlechas && (
          <button
            type="button"
            className="btn btn-light position-absolute"
            onClick={() => scroll("right")}
            style={{
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              borderRadius: "50%",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
            }}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        )}
      </div>
    </>
  );
};

export default CardTipo;